export const CANVAS_WIDTH = 1920;
export const CANVAS_HEIGHT = 1080;

export const CURRENT_SESSION_INDEX = -1;
